module.exports = "/_next/static/images/95e07256ddae9eb2eb7ac68b9e68d4bc-boy-looking-to-the-front-md@2x.jpg";